<div class="text-center">
  <img src="./assets/Images/Logo2.svg" alt="Logo">
</div>
<div class="logout">
  <div class="mobile-response">
    <div class="card mx-auto">
      <div class="card-body p-0">
        <span class="icon-check-circle mb-4"></span>
        <h4>Sie haben sich erfolgreich abgemeldet</h4>
        <p>Sie wurden abgemeldet. Bitte verwenden Sie den Einladungslink in Ihrer E-Mail, um erneut auf die Upload-Funktion zuzugreifen.</p>
      </div>
    </div>
  </div>
  <footer>
    <a [href]="'https://www.ing-plus.de/datenschutz'" target="_blank" style="text-decoration: none" class="link-btn">Datenschutzerklärung   </a> |
    <a [href]="'https://www.ing-plus.de/impressum'" target="_blank" style="text-decoration: none"  class="link-btn">   Impressum </a>
  </footer>
</div>

